module.exports = __webpack_public_path__ + "img/back-arrow.003964e5.svg";